import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import core from "./common/core";
import app from "./common/app";
import config from "./common/config";
//import 'promise-polyfill/src/polyfill';
let cookie = app.getLoginCookie();
core.addClassToElement(document, "body", `si-predictor`, false);
core.addClassToElement(
  document,
  "body",
  `si-${config.CURRENT_LANGUAGE.toLocaleLowerCase()}`,
  false
);
config.IS_MOBILE = core.isMobile();
config.IS_TABLET = core.isTablet();
if (cookie) {
  let saveQuestion = core.getCookie(config.enumBusters.saveQuestion);
  if (!saveQuestion || isNaN(saveQuestion)) {
    core.CompCacheBusterCookie(config.enumBusters.saveQuestion);
  }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("gamesPredictor")
);

/* // If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister(); */
